import Autocomplete from '../Autocomplete/Autocomplete';
import QuestionnaireItem from './QuestionnaireItem';

export default function QuestionnaireAutocompleteSmall(props) {
	return (
		<Autocomplete
			{...props}
			itemTemplate={props => <QuestionnaireItem {...props} user={props.item} />}
		/>
	);
}
